module.exports = __webpack_public_path__ + "static/Logo-a28f8ad5ed7771aa3fde7b49d8fa404b.png";